import { InfoCircle } from "@untitledui/icons";
import type { ReactNode } from "react";
import type { MerchantDraftItem } from "@/api/workspace-merchants";
import { merchantDraftProgress } from "@/utils/merchant-draft-progress";

export const MerchantInProgressBanner = ({ draft, action }: { draft: MerchantDraftItem; action?: ReactNode }) => {
  const progress = merchantDraftProgress(draft);
  const isConnected = !!draft.shopConnectedAt;

  return (
    <div role="status" className="flex min-h-24 rounded-lg overflow-hidden">
      <div className="relative w-[116px] shrink-0 bg-[#332148] max-sm:hidden" aria-hidden="true">
        <img
          src="/safety/aa254be04a7ba1180f1bbe583d7b9922e26a1a8a.png"
          alt=""
          className="absolute inset-0 size-full object-cover opacity-70"
        />
      </div>
      <div
        className="flex flex-1 flex-wrap items-center gap-6 px-6 py-5"
        style={{
          background: "linear-gradient(168.3deg, rgb(50,32,71) 24.455%, rgb(75,46,97) 55.212%, rgb(61,38,83) 78.446%)",
        }}
      >
        <div className="flex flex-col items-start gap-1.5">
          <p className="flex items-center gap-2 text-md font-semibold text-unbox-cream-25">
            <InfoCircle className="size-5" />
            New merchant in progress
          </p>
          {isConnected ? (
            <span className="rounded-full border border-success-200 bg-success-50 px-2.5 py-0.5 text-sm font-medium text-success-700">
              TikTok shop Connected
            </span>
          ) : (
            <span className="rounded-full border border-error-200 bg-error-50 px-2.5 py-0.5 text-sm font-medium text-error-700">
              TikTok shop not Connected yet
            </span>
          )}
        </div>
        <div className="flex flex-1 items-center justify-end gap-3 min-w-[240px]">
          <div
            className="h-2 w-full max-w-[400px] rounded-lg bg-unbox-cream-25/30 overflow-hidden"
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Setup progress"
          >
            <div
              className="h-full rounded-lg bg-[#abebdd] transition-[width] duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="text-sm font-medium text-unbox-cream-25 whitespace-nowrap">{progress}% complete</span>
        </div>
        {action}
      </div>
    </div>
  );
};
